import { FC } from 'react';
import * as Slider from '@radix-ui/react-slider';

type Props = {
  max: number;
  min: number;
  step?: number;
  defaultValue?: number[];
  onChange: (value: number) => void;
};

export const RangeSlider: FC<Props> = ({
  max,
  min,
  step,
  defaultValue,
  onChange,
}) => {
  return (
    <Slider.Root
      className="group relative flex items-center select-none w-full cursor-pointer focus:outline-none"
      defaultValue={defaultValue}
      max={max}
      min={min}
      step={step}
      onValueChange={(val) => onChange(val[0])}
    >
      <Slider.Track className="relative rounded-full bg-gray-200 h-2 w-full">
        <Slider.Range className="absolute rounded-full bg-primary-600 h-2" />
      </Slider.Track>
      <Slider.Thumb className="block w-6 h-6 rounded-full bg-base-white border-2 border-primary-600 group-hover:border-primary-700 shadow-md focus:outline-none focus-within:outline-none" />
    </Slider.Root>
  );
};
